import classNames from "classnames"
import { DateTime } from "luxon"
import { useEffect, useState } from "react"
import { getMaintenanceNotice, hideAfter, MAINTENANCE_DETAIL } from "./maintenanceWindow"
import styles from "./MaintenanceNotice.module.scss"

// Re-evaluated every minute so the notice switches to "in progress" and then
// disappears without a page reload. Stops ticking once the notice is gone.
const useNow = () => {
    const [now, setNow] = useState(() => DateTime.now())
    const expired = now >= hideAfter
    useEffect(() => {
        if (expired) return
        const id = window.setInterval(() => setNow(DateTime.now()), 60_000)
        return () => window.clearInterval(id)
    }, [expired])
    return now
}

type Props = {
    // "topbar": one-line pill inside the topbar, from 992px up (below that the
    // theme wraps the topbar onto two rows). "strip": full-width strip above
    // the page below 992px, with room for the detail that is otherwise only in
    // the hover tooltip. Both are mounted; CSS shows the one that fits.
    variant: "topbar" | "strip"
}

const MaintenanceNotice = ({ variant }: Props) => {
    const notice = getMaintenanceNotice(useNow())
    if (!notice) return null

    const { headline, summary, windowLabel } = notice

    return (
        <div
            className={classNames(styles.notice, styles[variant])}
            role="status"
            title={`${headline}: ${windowLabel}. ${MAINTENANCE_DETAIL}`}
        >
            <i className="pi pi-exclamation-triangle" aria-hidden="true" />
            <span className={styles.text}>
                <strong>{headline}</strong> · {windowLabel} · {summary}
                {variant === "strip" && <span className={styles.detail}>{MAINTENANCE_DETAIL}</span>}
            </span>
        </div>
    )
}

export default MaintenanceNotice
